export const injectJavaScriptText = `
class EventEmit {
  events = [];
  onceEvents = {};

  on(event, callback) {
    this.events[event] = this.events[event] || [];
    const events = this.events[event];
    if (!events.includes(callback)) {
      events.push(callback);
    }
  }

  once(event, callback) {
    this.onceEvents[event] = this.onceEvents[event] || [];
    const events = this.onceEvents[event];
    if (!events.includes(callback)) {
      events.push(callback);
    }
  }

  off(event, callback) {
    if (!callback) {
      this.events[event] = [];
      return;
    }
    const events = this.events[event] || [];
    const idx = events.findIndex(i => i === callback);
    if (idx > -1) {
      events.splice(idx, 1);
    }
  }

  emit(event, ...args) {
    const events = this.events[event] || [];
    events.forEach(callback => {
      callback(...args);
    });
    const events2 = this.onceEvents[event] || [];
    events2.forEach(callback => {
      callback(...args);
      const idx = events2.findIndex(i => i === callback);
      if (idx > -1) {
        events2.splice(idx, 1);
      }
    });
  }
}

const sign = '#suxue#';
function getRandomMessageId(name = 'default') {
  return name + Math.random();
}
function combineEventAndData(eventName, data, needResponse) {
  let content = data;
  if (typeof content !== 'string') {
    try {
      content = JSON.stringify(data);
    } catch (e) {}
  }
  return eventName + sign + content + (needResponse
    ? sign + getRandomMessageId()
    : '');
}

function splitEventAndData(data) {
  const arr = data.split(sign);
  let content = arr[1];
  try {
    content = JSON.parse(content);
  } catch (e) {}
  return {
    eventName: arr[0],
    data: content,
    responseEventName: arr[2],
  };
}
class WebviewJSBridge {
  // 管理需要响应的事件
  eventBus = new EventEmit();
  timeout = 20000;
  postMessage;
  middlewares=[];
  constructor(middlewares, postMessage) {
    this.postMessage = postMessage;
    this.middlewares.push(...middlewares);
  }
  request = (config) => {
    const body = combineEventAndData(
      config.eventName,
      config.data,
      config.needResponse,
    );
    console.log('JSBridgeRequestBody',config, body)
    this.postMessage(body);
    return new Promise((resolve, reject) => {
      if(config.needResponse){
        const {responseEventName} = splitEventAndData(body);
        this.eventBus.once(responseEventName, (resData, done) => {
          done();
          resolve(resData);
        });
        if (!config.promiseResponse) {
            setTimeout(() => {
              this.eventBus.off(responseEventName)
              reject();
            }, this.timeout);
        }
      }else{
        resolve();
      }
    });
  }
  onMessage = (event) => {
    if(!event.data.includes(sign))return
    const {eventName, data, responseEventName} = splitEventAndData(event.data);
    let isRet = false;
    const res = dataMessage => {
      if (responseEventName) {
        this.request({
          eventName: responseEventName,
          needResponse: false,
          data: dataMessage,
        });
      }
      isRet = true;
    };
    this.eventBus.emit(eventName, data, () => (isRet = true));

    // 处理来自对方的响应事件
    for (let i in this.middlewares) {
      if (!isRet) {
        this.middlewares[i](eventName, data, res);
      }
    }
  }
  addMiddleware(middleware) {
    this.middlewares.push(middleware);
  }
}
(function() {
            window.postMessage = function(data) {
              window.ReactNativeWebView.postMessage(data)
            }
            })()
console.log(location.href)
window.WebviewJSBridge = WebviewJSBridge
window.webviewJSBridge = new WebviewJSBridge([],window.postMessage)
document.removeEventListener('message', window.webviewJSBridge.onMessage)
document.addEventListener('message', window.webviewJSBridge.onMessage)
`;

export const injectJavaScriptWithMessage = `
(function() {
            window.postMessage = function(data) {
              window.ReactNativeWebView.postMessage(data)
            }
            })()
`;
